export default __webpack_public_path__ + "static/media/imagefile.7ba8e042.png";